import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Trophy, Sparkles, Tag, Archive, CircleX } from 'lucide-react';

export type ProductLifecycleStatus = 'best_seller' | 'en_promotion' | 'fin_de_serie' | 'archive';

const statusMeta: Record<ProductLifecycleStatus, { label: string; icon: React.ElementType; variant?: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
  best_seller: { label: 'Best-seller', icon: Trophy, variant: 'default' },
  en_promotion: { label: 'En promotion', icon: Tag, variant: 'secondary' },
  fin_de_serie: { label: 'Fin de série', icon: CircleX, variant: 'destructive' },
  archive: { label: 'Archivé', icon: Archive, variant: 'outline' },
};

interface StatusBadgeProps {
  status: ProductLifecycleStatus;
  compact?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, compact = true }) => {
  const meta = statusMeta[status];
  const Icon = meta.icon;
  return (
    <Badge variant={meta.variant ?? 'secondary'} className={compact ? 'px-2 py-0.5' : ''}>
      <Icon className="w-3.5 h-3.5 mr-1" /> {meta.label}
    </Badge>
  );
};
